import { useState } from "react";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import styles from "./sorting-options.module.less";
import { GhostButton, RadioButtons } from "@parksandresorts/core";

export const SORT_OPTIONS = {
  popularity: "popularity",
  waitTime: "waitTime",
  queueTime: "queueTime",
  alphabetical: "alphabetical",
};

const SORT_LABELS = {
  [SORT_OPTIONS.popularity]: SiteConfigurationStore.getLabel("SORT_OPTION_POPULARITY", "Popularitet"),
  [SORT_OPTIONS.waitTime]: SiteConfigurationStore.getLabel("SORT_OPTION_WAIT_TIME", "Väntetid"),
  [SORT_OPTIONS.queueTime]: SiteConfigurationStore.getLabel("SORT_OPTION_QUEUE_TIME", "Kötid"),
  [SORT_OPTIONS.alphabetical]: SiteConfigurationStore.getLabel("SORT_OPTION_ALPHABETICAL", "Namn (A-Ö)"),
};

const RadioButtonLabel = ({ active, label }) => (
  <div className={[styles.radioButtonLabelWrapper, active ? styles.active : ""].join(" ")}>
    <span
      className={[styles.iconLeft, active ? "icon-radio-button-checked" : "icon-radio-button-unchecked"].join(" ")}
    ></span>
    <span className={styles.radioButtonLabel}>{label}</span>
  </div>
);

const getSortingOptions = (selectedSorting, showWaitTimeSorting, showQueueTimeSorting, componentId) => {
  let sortingOptions = [
    {
      id: `${SORT_OPTIONS.alphabetical}_${componentId}`,
      key: SORT_OPTIONS.alphabetical,
      label: (
        <RadioButtonLabel
          active={selectedSorting === SORT_OPTIONS.alphabetical}
          label={SORT_LABELS[SORT_OPTIONS.alphabetical]}
        />
      ),
      value: SORT_OPTIONS.alphabetical,
      name: SORT_OPTIONS.alphabetical,
      disabled: false,
    },
    {
      id: `${SORT_OPTIONS.popularity}_${componentId}`,
      key: SORT_OPTIONS.popularity,
      label: (
        <RadioButtonLabel
          active={selectedSorting === SORT_OPTIONS.popularity}
          label={SORT_LABELS[SORT_OPTIONS.popularity]}
        />
      ),
      value: SORT_OPTIONS.popularity,
      name: SORT_OPTIONS.popularity,
      disabled: false,
    },
  ];

  if (showWaitTimeSorting) {
    sortingOptions = [
      ...sortingOptions,
      {
        id: `${SORT_OPTIONS.waitTime}_${componentId}`,
        key: SORT_OPTIONS.waitTime,
        label: (
          <RadioButtonLabel
            active={selectedSorting === SORT_OPTIONS.waitTime}
            label={SORT_LABELS[SORT_OPTIONS.waitTime]}
          />
        ),
        value: SORT_OPTIONS.waitTime,
        name: SORT_OPTIONS.waitTime,
        disabled: false,
      },
    ];
  }

  if (showQueueTimeSorting) {
    sortingOptions = [
      ...sortingOptions,
      {
        id: `${SORT_OPTIONS.queueTime}_${componentId}`,
        key: SORT_OPTIONS.queueTime,
        label: (
          <RadioButtonLabel
            active={selectedSorting === SORT_OPTIONS.queueTime}
            label={SORT_LABELS[SORT_OPTIONS.queueTime]}
          />
        ),
        value: SORT_OPTIONS.queueTime,
        name: SORT_OPTIONS.queueTime,
        disabled: false,
      },
    ];
  }

  return sortingOptions;
};

const SortingOptions = ({ setSorting, selectedSorting, showWaitTimeSorting, showQueueTimeSorting }) => {
  const [showMobileSortingOptions, setShowMobileSortingOptions] = useState(false);
  // The radio buttons must have unique ids per component to map the labels to the correct input.
  const [componentId] = useState(Math.floor(Math.random() * 1000));
  const sortingOptions = getSortingOptions(selectedSorting, showWaitTimeSorting, showQueueTimeSorting, componentId);

  const changeSorting = (newSorting) => {
    setShowMobileSortingOptions(false);
    setSorting(newSorting);
  };

  return (
    <div className={["block--max-width", styles.sortingWrapper].join(" ")}>
      <h6 className={styles.sortingHeadline}>{SiteConfigurationStore.getLabel("SORT_HEADING", "Sortering")}</h6>
      <div className={styles.sortingButtonWrapper}>
        <GhostButton
          element="button"
          onClick={() => setShowMobileSortingOptions(!showMobileSortingOptions)}
          className={[showMobileSortingOptions ? styles.sortingVisible : undefined, styles.toggleSortingButton].join(
            " ",
          )}
          label={SORT_LABELS[selectedSorting]}
          iconRight={{ icon: showMobileSortingOptions ? "icon-close" : "icon-chevron-down" }}
        />
      </div>
      <div className={[styles.sortingList, showMobileSortingOptions ? styles.visible : ""].join(" ")}>
        <RadioButtons
          options={sortingOptions}
          value={selectedSorting}
          name="sortingOptions"
          itemWrapperClassName={styles.itemWrapper}
          onChange={(name, selected) => changeSorting(selected)}
        />
      </div>
    </div>
  );
};

export default SortingOptions;
